import React from 'react'
import PropTypes from 'prop-types'

const ContentItemSelectionError = props => {
  return (
    <div className="text-center">
      <img src="/static/base_app/media/logos/wordmark-blue-300.png" />
      <div className="text-center lead mt-5 alert alert-danger">
        There was an error retrieving the items. Contact MyEducator support for
        further information. <br />
        ERROR: {props.error}
      </div>
    </div>
  )
}

ContentItemSelectionError.propTypes = {
  error: PropTypes.string,
}

export default ContentItemSelectionError
